import 'globals';

(function($, window, document, PageLoadedQueue) {
    PageLoadedQueue.push(function() {
        if ($.prototype.slick) {
            $('.slider__items').slick();
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
